import { Dialog, DialogContent } from '@talentmesh/ui/components/dialog';
import { cn } from '@talentmesh/ui/lib/utils';
import AssessmentResetDialogActions from './AssessmentResetDialogActions';
import AssessmentResetDialogBody from './AssessmentResetDialogBody';
import AssessmentResetDialogHeader from './AssessmentResetDialogHeader';

export interface AssessmentResetDialogProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onConfirm: () => Promise<void>;
}

const AssessmentResetDialog = ({ open, setOpen, onConfirm }: AssessmentResetDialogProps) => {
    return (
        <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && setOpen(false)}>
            <DialogContent showCloseButton={false} className={cn('flex max-w-lg flex-col gap-4 p-6 sm:max-w-lg')}>
                <AssessmentResetDialogHeader />
                <AssessmentResetDialogBody />
                <AssessmentResetDialogActions onCancel={() => setOpen(false)} onConfirm={onConfirm} />
            </DialogContent>
        </Dialog>
    );
};

export default AssessmentResetDialog;
